import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, UserPlus } from "lucide-react";

export const NewCustomerInline = ({ initialName, onCreated, onCancel }) => {
  const [c, setC] = useState({ full_name: initialName || "", email: "", telephone: "" });
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setC((s) => ({ ...s, [k]: v }));

  const create = async () => {
    const name = c.full_name.trim(), email = c.email.trim().toLowerCase(), tel = c.telephone.trim();
    if (!name) return toast.error("Customer name is required");
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return toast.error("Enter a valid email address");
    setBusy(true);
    try {
      if (email) {
        const r = await api.get("/contacts", { params: { q: email, page: 1, page_size: 5 } });
        const dup = (r.data.items || []).find((x) => (x.email || "").toLowerCase() === email);
        if (dup) { toast.error(`A customer with this email already exists: ${dup.full_name}`); return; }
      }
      const r = await api.post("/contacts", { full_name: name, email: email || null, telephone: tel || null, user_type: "Customer" });
      toast.success("Customer created");
      onCreated(r.data.contact);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not create customer");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-2 rounded-2xl border border-indigo-100 bg-indigo-50/40 p-4 space-y-3" data-testid="job-new-customer-panel">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-800"><UserPlus className="w-4 h-4 text-indigo-600" /> New customer</div>
      <Input value={c.full_name} onChange={(e) => set("full_name", e.target.value)} placeholder="Full name" data-testid="job-new-customer-name" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <Input type="email" value={c.email} onChange={(e) => set("email", e.target.value)} placeholder="Email" data-testid="job-new-customer-email" />
        <Input type="tel" value={c.telephone} onChange={(e) => set("telephone", e.target.value)} placeholder="Phone" data-testid="job-new-customer-phone" />
      </div>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={onCancel} data-testid="job-new-customer-cancel">Cancel</Button>
        <Button type="button" size="sm" onClick={create} disabled={busy} className="gap-1.5 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="job-new-customer-create">
          {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Create &amp; link
        </Button>
      </div>
    </div>
  );
};
